import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionBadgeComponent } from './section-badge/section-badge.component';



@NgModule({
  declarations: [
    SectionBadgeComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SectionBadgeComponent
  ]
})
export class SharedModule { }
